import { render, staticRenderFns } from "./CorporateCustomer.vue?vue&type=template&id=0738e960&"
import script from "./CorporateCustomer.vue?vue&type=script&lang=js&"
export * from "./CorporateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CorporateCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports